import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'
import 'velocity-animate/velocity.min.js'
import 'velocity-animate/velocity.ui.min.js'
import 'owl.carousel.css'
import 'owl.carousel.js'

import Utils from 'front/utils/Utils.js'
import Frame from 'front/components/Frame/Frame.js'
import BaseView from 'front/components/BaseView/BaseView.js'

import './Slider.css'
import template from './Slider.jinja'


var Slider = BaseView.extend({
    events: {
        'click .Slider-btn--prev': 'slidePrev',
        'click .Slider-btn--next': 'slideNext',
        'translate.owl.carousel .owl-carousel': 'changeSlide',
        'drag.owl.carousel .owl-carousel': 'dragStart',
        'dragged.owl.carousel .owl-carousel': 'dragEnd'
    },

    initialize (options) {
        _.bindAll(this, 'activateTitle', 'activateImage')

        this.$slider = this.$('.Slider-contents')

        let config = {
            items: 1,
            mouseDrag: false,
            loop: true,
            nav: false,
            navSpeed: 1000,
            smartSpeed: 1000
        }

        this.state = {
            dragging: false
        }

        if (options.type === 'project') {
            _.extend(config, {
                center: true,
                stagePadding: 428,
                margin: 48
            })
        }

        this.$slider.owlCarousel(config)

        this.$firstSlide = this.$('.owl-item.active').find('.Slider-slide')
        this.$firstTitle = this.$firstSlide.find('.Slider-link')
        this.$firstTitle.addClass('isNotActive')

        this.$firstImg = this.$firstSlide.find('.Slider-img')
        this.$frame = this.$firstSlide.find('.Frame')

        if (this.$frame.length) {
            this.modifyFrame()
        }

        this.$counter = this.$('.Slider-counter')
        this.$currentCounter = this.$counter.find('.Slider-currentCounter')
        this.currentIndex = 0

        this.$arrows = this.$('.Slider-btn')

        this._arrowsShownBinded = this._arrowsShown.bind(this)

        this.$el[0].style.visibility = 'visible'
    },

    /**
     * Изменяет разметку компоненты Frame, для случая с анимацией
     */
        modifyFrame () {
        let $newFrame = (new Frame()).render().$el
        this.$frame = $newFrame.replaceAll(this.$frame)
    },

    activateTitle (options) {
        var self = this

        if (this.$firstTitle.length) {
            return $.Velocity.animate(this.$firstTitle[0], {opacity: 1}, _.extend({
                duration: 1500,
                complete () {
                    self.$firstTitle.removeClass('isNotActive')
                }
            }, options))
        } else {
            return Promise.resolve(true)
        }
    },

    deactivateTitle(options) {
        var $currentTitle = this.getCurrentSlide().find('.Slider-link')
        return $.Velocity.animate($currentTitle[0], {opacity: 0}, _.extend({duration: 1000}, options))
    },

    activateImage (options) {
        return $.Velocity.animate(this.$firstImg[0], {opacity: 1}, _.extend({duration: 1500}, options))
    },

    deactivateImage (options) {
        var $currentImg = this.getCurrentSlide().find('.Slider-img')
        return $.Velocity.animate($currentImg[0], {opacity: 0}, _.extend({duration: 500}, options))
    },

    activateArrows() {
        this.$arrows[0].addEventListener('transitionend', this._arrowsShownBinded)
        this.$arrows[0].addEventListener('webkitTransitionEnd', this._arrowsShownBinded)

        this.$arrows.removeClass('isNotActive')
    },

    deactivateArrows() {
        this.$arrows.addClass('isNotActive')
    },

    _arrowsShown() {
        this.$arrows.addClass('isActive')
    },

    activateCounter (options) {
        return $.Velocity.animate(this.$counter[0], {opacity: 1}, _.extend({duration: 500}, options))
    },

    deactivateCounter (options) {
        return $.Velocity.animate(this.$counter[0], {opacity: 0}, _.extend({duration: 500}, options))
    },

    activateFrame() {
        setTimeout(() => {
            this.$frame.addClass('isActive')
        }, 250)
    },

    changeCounter(e) {
        var newIndex = e.page.index + 1
        var indexFormatted = Utils.pad(newIndex, 2)
        var $newValue = $(`<span class="Slider-numberValue">${indexFormatted}</span>`)

        var $oldValue = this.$currentCounter.find('.Slider-numberValue')
        $oldValue.velocity('finish', true)

        if (newIndex > this.currentIndex) {
            this.currentIndex = newIndex

            $.Velocity.hook($oldValue, 'translateY', 0)
            $.Velocity.animate($oldValue, {translateY: '15px', opacity: 0}, {
                duration: 750,
                complete() {
                    $oldValue.remove()
                }
            })

            $.Velocity.hook($newValue[0], 'opacity', 0)
            $.Velocity.hook($newValue[0], 'translateY', '-15px')
            $newValue = $newValue.appendTo(this.$currentCounter)

            $.Velocity.animate($newValue[0], {translateY: 0, opacity: 1}, {duration: 750});
        } else {
            this.currentIndex = newIndex

            $.Velocity.hook($oldValue, 'translateY', 0)
            $.Velocity.animate($oldValue, {translateY: '-15px', opacity: 0}, {
                duration: 750,
                complete() {
                    $oldValue.remove()
                }
            })

            $.Velocity.hook($newValue[0], 'opacity', 0)
            $.Velocity.hook($newValue[0], 'translateY', '15px')
            $newValue = $newValue.appendTo(this.$currentCounter)

            $.Velocity.animate($newValue[0], {translateY: 0, opacity: 1}, {duration: 750})
        }
    },

    getCurrentSlide() {
        var sliderPosition = this.$slider.offset()
        var sliderCenterX = sliderPosition.left + this.$slider.width() / 2
        var sliderCenterY = sliderPosition.top + this.$slider.height() / 2
        return $(document.elementFromPoint(sliderCenterX, sliderCenterY)).closest('.owl-item')
    },

    changeSlide(e) {
        if (this.state.dragging) {
            return;
        }

        var newFakeIndex = e.page.index + 1
        var newRealIndex = e.item.index
        var $nextSlide = this.$slider.find('.owl-item').eq(newRealIndex)
        var $nextSlideTitle = $nextSlide.find('.Slider-linkContents')
        var $currentSlide = this.getCurrentSlide()

        // TODO: Refactor
        if (this.currentIndex === 3 && newFakeIndex === 1) {
            $.Velocity.hook($nextSlideTitle, 'opacity', '0')
            $.Velocity.hook($nextSlideTitle, 'translateX', -(parseInt(app.els.$window.width()) / 2) + 'px')
        } else if (this.currentIndex === 1 && newFakeIndex === 3) {
            $.Velocity.hook($nextSlideTitle, 'opacity', '0')
            $.Velocity.hook($nextSlideTitle, 'translateX', (parseInt(app.els.$window.width()) / 2) + 'px')
        } else if (newFakeIndex > this.currentIndex) {
            $.Velocity.hook($nextSlideTitle, 'opacity', '0')
            $.Velocity.hook($nextSlideTitle, 'translateX', -(parseInt(app.els.$window.width()) / 2) + 'px')
        } else {
            $.Velocity.hook($nextSlideTitle, 'opacity', '0')
            $.Velocity.hook($nextSlideTitle, 'translateX', (parseInt(app.els.$window.width()) / 2) + 'px')
        }

        var $title = $currentSlide.find('.Slider-linkContents')
        $.Velocity($title, {opacity: 0}, {
            duration: 500,
            complete() {
                setTimeout(() => {
                    $.Velocity.hook($title, 'opacity', '1')
                }, 500)
            }
        })

        $nextSlideTitle.velocity({
            opacity: [1, 'easeInQuad'],
            translateX: [0, 'easeOutQuart']
        }, {
            duration: 1000
        })

        this.changeCounter(e)
    },

    slidePrev() {
        this.$slider.trigger('prev.owl.carousel')
    },

    slideNext() {
        this.$slider.trigger('next.owl.carousel')
    },

    refresh () {
        this.$slider.data('owlCarousel')._width = this.$slider.width()
        this.$slider.data('owlCarousel').invalidate('width')
        this.$slider.trigger('refresh.owl.carousel')
    },

    dragStart () {
        this.state.dragging = true;
    },

    dragEnd() {
        this.state.dragging = false;
    }
})

export default Slider



// WEBPACK FOOTER //
// ./assets/app/front/components/Slider/Slider.js